module.exports = __webpack_public_path__ + "static/media/lei_seg.eb77deb0.m4a";